module.exports = __webpack_public_path__ + "dm.478c0a5f635217176e5b.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/dm.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/dm.svg
// module chunks = styles